import { Routes, Route } from 'react-router-dom'
import { lazy, Suspense } from 'react'
import { ProgressBarSuspenseFallback } from '@vivaldis/web-ui'

const VerificationsList = lazy(() => import('./Verifications'))

export const VerificationsRoutes = () => {
  return (
    <Suspense fallback={ProgressBarSuspenseFallback}>
      <Routes>
        <Route path="*" element={<VerificationsList />} />
      </Routes>
    </Suspense>
  )
}
